export const RS_CHANGE_DOUBLE_CHANCE = {
  title: "",
  dataTable: [
    {
      titleTable: "DOUBLE CHANCE+",
      descriptionTable: "DRAW FIRST [first] PREMIERS ET FIVE LAST NUMBERS",
      descriptionKeyFirst: "5",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        {
          title: "DOUBLE CHANCE+ [number]",
          key: "3",
          colspan: "",
        },
        {
          title: "MULTIPLIER",
          key: "",
          colspan: "2",
        },
      ],
      dataTableContent: [
        {
          number: "",
          first: "first [number] numbers",
          last: "last [number] numbers",
          keyNumber: "",
          keyFirst: "5",
          keyLast: "5",
        },
        {
          number: "[number] numbers",
          first: "1,850",
          last: "1,250",
          keyNumber: "3",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "31",
          last: "21",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
    {
      titleTable: "",
      descriptionTable: "",
      descriptionKeyFirst: "",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        {
          title: "DOUBLE CHANCE+ [number]",
          key: "4",
          colspan: "",
        },
        {
          title: "MULTIPLIER",
          key: "",
          colspan: "2",
        },
      ],
      dataTableContent: [
        {
          number: "",
          first: "first [number] numbers",
          last: "last [number] numbers",
          keyNumber: "",
          keyFirst: "5",
          keyLast: "5",
        },
        {
          number: "[number] numbers",
          first: "18,000",
          last: "12,000",
          keyNumber: "4",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "180",
          last: "120",
          keyNumber: "3",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "18",
          last: "12",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
    {
      titleTable: "",
      descriptionTable: "",
      descriptionKeyFirst: "",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        {
          title: "DOUBLE CHANCE+ [number]",
          key: "5",
          colspan: "",
        },
        {
          title: "MULTIPLIER",
          key: "",
          colspan: "2",
        },
      ],
      dataTableContent: [
        {
          number: "",
          first: "first [number] numbers",
          last: "last [number] numbers",
          keyNumber: "",
          keyFirst: "5",
          keyLast: "5",
        },
        {
          number: "[number] numbers",
          first: "120,000",
          last: "80,000",
          keyNumber: "5",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "6,000",
          last: "4,000",
          keyNumber: "4",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "120",
          last: "80",
          keyNumber: "3",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "9",
          last: "6",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
  ],
};
